module.exports = __webpack_public_path__ + "38d1aea0ee87bce8f6be3f7ade7a8ebe.jpg";